import Explanation from '../explanation';
import Header from './../../game/header';

import './styles.css';

export default function Layout({
  backgroundImage,
  backgroundColor,
  isBackgroundBlurred,
  isHeaderVisible,
  isFooterVisible,
  isContentVertical,
  time,
  totalScore,
  isExplanationVisible,
  isAvatarVisible,
  explanationName,
  answerStatus,
  explanationContent,
  shouldExplanationContentBeParsed,
  children,
  scoreLabel = "Mastery Index",
  className = '',
  middleHeaderButtonText,
  middleHeaderButtonClassName,
  middleHeaderButtonDataTourId,
  onMiddleHeaderButtonClick,
  middleButtonTitle,
  isMiddleButtonLoading
}) {
  const isGradient = backgroundColor && (
    backgroundColor.includes('gradient') || 
    backgroundColor.includes('linear') || 
    backgroundColor.includes('radial')
  );
  
  const backgroundStyle = {
    ...(backgroundImage ? { backgroundImage: `url(${backgroundImage})` } : {}),
    ...(backgroundColor ? (
      isGradient 
        ? { background: backgroundColor } 
        : { backgroundColor }
    ) : {}),
  };

  return (
    <div className={`game-level-wrapper intro-game-level-wrapper ${className} ${isBackgroundBlurred ? 'blurred' : ''}`} style={backgroundStyle}>
      {
        isHeaderVisible &&
          <Header
            time={time}
            totalScore={totalScore}
            scoreLabel={scoreLabel}
            middleButtonText={middleHeaderButtonText}
            middleHeaderButtonClassName={middleHeaderButtonClassName}
            middleHeaderButtonDataTourId={middleHeaderButtonDataTourId}
            onMiddleButtonClick={onMiddleHeaderButtonClick}
            middleButtonTitle={middleButtonTitle}
            isMiddleButtonLoading={isMiddleButtonLoading}
          />
      }
      <div className={`page-content intro-game-level-page-content ${isContentVertical ? 'vertical' : ''}`} >
        {children}
      </div>
      {
        isFooterVisible &&
          <footer className="intro-game-level-page-footer">
            {
              isExplanationVisible &&
                <Explanation 
                  isAvatarVisible={isAvatarVisible}
                  name={explanationName}
                  status={answerStatus}
                  content={explanationContent}
                  shouldContentBeParsed={shouldExplanationContentBeParsed}
                />
            }
          </footer>
      }
    </div>
  );
}
